import { DEFAULT_PAGE_NUMBER } from '../../../constants/oneLink';
import { useGetEngagements } from '../../../service/EngagementService';
import { MARKETPLACE_FULFILLMENT_CENTER_ID } from '../../../types/marketplace';

const COUNT_ONLY_PAGE_SIZE = 1;

export interface IOneLinkSourceCountsOptions {
  enabled?: boolean;
  totalCount?: number;
}

export interface IOneLinkSourceCounts {
  marketplace: number;
  inventory: number;
  isLoading: boolean;
}

export const useOneLinkSourceCounts = (
  oneLinkId?: string,
  { enabled = true, totalCount = 0 }: IOneLinkSourceCountsOptions = {},
): IOneLinkSourceCounts => {
  const shouldFetch = enabled && !!oneLinkId;

  const marketplaceQuery = useGetEngagements(
    {
      ...(oneLinkId ? { one_link_id: oneLinkId } : {}),
      fulfillment_center_ids: [MARKETPLACE_FULFILLMENT_CENTER_ID],
      page: DEFAULT_PAGE_NUMBER,
      page_size: COUNT_ONLY_PAGE_SIZE,
    },
    { enabled: shouldFetch },
  );

  const marketplace = marketplaceQuery.data?.total_count ?? 0;

  return {
    marketplace,
    inventory: Math.max(totalCount - marketplace, 0),
    isLoading: marketplaceQuery.isFetching,
  };
};
